export const MapTypes = {

    HYBRID: {text: 'Hybrid', value: 'hybrid'},
    TERRAIN: {text: 'Terrain', value: 'terrain'},
    ROADMAP: {text: 'Roadmap', value: 'roadmap'},
    SATELLITE: {text: 'Satellite', value: 'satellite'},

    list() {
        return [
            this.HYBRID,
            this.TERRAIN,
            this.ROADMAP,
            this.SATELLITE
        ]
    },

}
